import * as Sentry from "@sentry/nuxt";

const runtimeConfig = useRuntimeConfig();

Sentry.init({
  dsn: runtimeConfig.public.sentryDsn as string,

  tracesSampleRate: 1.0,

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  integrations: [Sentry.replayIntegration()],

  debug: false,
});
